import React from "react";

import Modals from "../popupModal/modal";

const ConfirmationModal = ({ isOpen, onSuccess, closeModal, titleText, confirmButtonText, modalContent, modalStyle={} }) => {
  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title={titleText}
      styles={{
        content: {
          minWidth: "552px",
          minHeight: "350px",
          ...modalStyle
        },
      }}
      btnDark={{
        label: `${confirmButtonText}`,
        onclick: () => {
          onSuccess();
          closeModal();
        },
      }}
      btnOutline={{
        label: "Cancel",
        onclick: () => {
          closeModal();
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p className="mx-auto text-center denyAppointmentText">
          {modalContent}
        </p>
      </React.Fragment>
    </Modals>
  );
};

export default ConfirmationModal;
